import { render } from "./Informacion.vue?vue&type=template&id=2a551e9c"
import script from "./Informacion.vue?vue&type=script&lang=js"
export * from "./Informacion.vue?vue&type=script&lang=js"
script.render = render

export default script